import { Button, Modal } from 'react-daisyui';
import { XCircleIcon } from '@heroicons/react/24/solid';
import { tBlockedLeadModal } from './BlockedLeadModal.types';

/**
 * Modal component that displays a warning when a lead has blocked or unsubscribed.
 * Shows a message indicating that no more messages can be sent to this contact.
 * @param props - Component props containing isOpen state and onClose handler.
 * @returns JSX.Element - The rendered modal component.
 */
export default function BlockedLeadModal(
  props: tBlockedLeadModal,
): JSX.Element {
  const { isOpen, onClose } = props;

  return (
    <Modal open={isOpen} backdrop={true} responsive={true}>
      <Modal.Body className="flex flex-col items-center text-center p-6">
        <XCircleIcon className="w-24 h-24 text-red-500 mb-4" />
        <h2 className="text-xl font-bold text-gray-800 mb-4">
          No puedes enviar mensajes.
        </h2>
        <p className="text-gray-600 mb-6">
          Este lead pudo haberte bloqueado o dar de baja este número. Por favor,
          no envíes más mensajes a este contacto o tu cuenta puede ser
          bloqueada.
        </p>
        <div className="flex gap-8 w-full justify-center">
          <Button
            className="btn-primary min-w-32"
            onClick={onClose}
          >
            Entendido
          </Button>
        </div>
      </Modal.Body>
    </Modal>
  );
}
